<div class="row col-12 p-0 m-0 not-found-container main-page-section ">
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="not-found-section row">
      <div class="col-5">
        <div class="not-found-content">
          <p class="title">Page is not available</p>
          <p class="description">The link you clicked may be broken or the
            page may have been removed.</p>
          <p class="go-back" routerLink="/overview">Go Back to overview</p>
        </div>
      </div>
      <div class="col-7">
        <div class="not-found-image">
          <img src="../../../../../../assets/images/error-page/not-found.svg" alt="not found image" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</div>
